import jackPic from "@/public/images/artists/jack.png";
import { Artist } from "@/types/types";

export const jack = {
  id: "122",
  name: "Jack",
  image: jackPic,
  description: `Jack's voice is characterized by a youthful timbre, marked by a balance between clarity and a gritty edge, often conveying a sense of vulnerability intertwined with assertiveness.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjack-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "RnB", "Hip Hop", "Alternative"],
      secondary: ["Youthful"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 48,
        high: 68,
      },
    },
  },
} as const satisfies Artist;
